export default __webpack_public_path__ + "img/2e61470b3e84997db2c4573bcd666912.svg";